const getRectAnchor = (rect) => ({
    x: rect.x - rect.width * 0.5,
    y: rect.y - rect.height * 0.5,
});
export const isPointInRect = (rect, x, y) => {
    const { x: rx, y: ry } = getRectAnchor(rect);
    return x >= rx && x <= rx + rect.width && y >= ry && y <= ry + rect.height;
};
/**
 * Returns straignt lines and arc segments for rounded corners
 * All angles are defined as their are in Math.atan2 function return
 *
 * @param rect
 * @returns
 */
const getRoundedRectSegments = (rect) => {
    const result = [];
    const { x, y } = getRectAnchor(rect);
    const lwidth = rect.width - 2 * rect.radius;
    const lheight = rect.height - 2 * rect.radius;
    // angles for arc are defined based on atan2
    // return values i.e. counterclockwise in range [-Pi,Pi]
    // tl
    result.push({
        type: 'arc',
        center: { x: x + rect.radius, y: y + rect.radius },
        radius: rect.radius,
        angleFrom: -Math.PI,
        angleTo: -Math.PI / 2,
    });
    // top
    result.push({
        type: 'line',
        start: { x: x + rect.radius, y },
        end: { x: x + rect.radius + lwidth, y },
    });
    // tr
    result.push({
        type: 'arc',
        center: { x: x + rect.width - rect.radius, y: y + rect.radius },
        radius: rect.radius,
        angleFrom: -Math.PI / 2,
        angleTo: 0,
    });
    // right
    result.push({
        type: 'line',
        start: { x: x + rect.width, y: y + rect.radius },
        end: { x: x + rect.width, y: y + rect.radius + lheight },
    });
    // br
    result.push({
        type: 'arc',
        center: {
            x: x + rect.width - rect.radius,
            y: y + rect.height - rect.radius,
        },
        radius: rect.radius,
        angleFrom: 0,
        angleTo: Math.PI / 2,
    });
    // bottom
    result.push({
        type: 'line',
        start: { x: x + rect.radius + lwidth, y: y + rect.height },
        end: { x: x + rect.radius, y: y + rect.height },
    });
    // bl
    result.push({
        type: 'arc',
        center: { x: x + rect.radius, y: y + rect.height - rect.radius },
        radius: rect.radius,
        angleFrom: Math.PI / 2,
        angleTo: Math.PI,
    });
    // left
    result.push({
        type: 'line',
        start: { x, y: y + rect.radius + lheight },
        end: { x, y: y + rect.radius },
    });
    return result;
};
/**
 * Returns straight line segments building a rectangle
 * @param rect
 * @returns
 */
const getRectangularRectSegments = (rect) => {
    const result = [];
    const { x, y } = getRectAnchor(rect);
    const deltas = [
        [0, 0],
        [1, 0],
        [1, 1],
        [0, 1],
    ];
    deltas.forEach((delta, index, arr) => {
        const sd = delta;
        const ed = arr[(index + 1) % arr.length];
        const segment = {
            type: 'line',
            start: {
                x: x + sd[0] * rect.width,
                y: y + sd[1] * rect.height,
            },
            end: {
                x: x + ed[0] * rect.width,
                y: y + ed[1] * rect.height,
            },
        };
        result.push(segment);
    });
    return result;
};
/**
 * Divide rectangle (or rounded rectangle) into an array of segments
 * For non-rounded rect this returns 4 straight segments.
 * For rounded rect corner arcs are added
 */
export const getRectSegments = (rect) => {
    const hasRoundedCorners = rect.radius > 0;
    if (hasRoundedCorners) {
        return getRoundedRectSegments(rect);
    }
    return getRectangularRectSegments(rect);
};
